

import router from "@/router";




import admin from '@/container/admin'
//import prodocts from '@/components/prodocts/prodocts'

const Login = () => import('Views/session/Login')


router.addRoute({
    name: 'homepage' ,
    path: '/', 
    component: admin ,
    meta: {
        requiresAuth: true,
        //title: 'message.dashboard1',
        //breadcrumb: 'message.dashboardDashboard1'
    }
})
router.addRoute({ name: 'login' ,path: '/session/Login/', component: Login })
/*
router.addRoute({
    name: 'prodocts' ,
    path: '/admin/prodocts/', 
    component: prodocts ,
    meta: {
        requiresAuth: true,
        //title: 'message.dashboard1',
        //breadcrumb: 'message.dashboardDashboard1'
    }
})
*/

//

export default router